import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { FeathersService } from './feathers.service';
import { IGroup } from '@alberta/konexi-shared';

@Injectable({
  providedIn: 'root',
})
export class GroupService extends BaseService<IGroup> {
  constructor(feathers: FeathersService) {
    super('group', feathers.app);
  }
}
